export * from './FileTypePresentationIcon';
export * from './FileTypePresentationIcon16Light';
export * from './FileTypePresentationIcon16Regular';
export * from './FileTypePresentationIcon16Solid';
export * from './FileTypePresentationIcon20Light';
export * from './FileTypePresentationIcon20Regular';
export * from './FileTypePresentationIcon20Solid';
export * from './FileTypePresentationIcon24Regular';
export * from './FileTypePresentationIcon24Solid';
export * from './FileTypePresentationIcon32Regular';
export * from './FileTypePresentationIcon64Regular';
